let delivery_jQuery = null;
let themeScript_currentUrl = window.location.href.split("/");
document.addEventListener("DOMContentLoaded", (event) => {
  disableCheckout();
});
getJQuery().then(() => {
  delivery_jQuery("document").ready(() => {
    if (
      __st.p === "product"
    ) {
      disableAddToCart();
    } else {
      disableCheckout();
    }
  });
});

function getJQuery() {
  return new Promise((resolve) => {
    const wantedVersion = "1.9.1";
    if (
      typeof jQuery === "undefined" ||
      parseFloat(jQuery.fn.jquery) < parseFloat(wantedVersion)
    ) {
      getScript({
        source: `//ajax.googleapis.com/ajax/libs/jquery/${wantedVersion}/jquery.min.js`,
      }).then(() => {
        delivery_jQuery = jQuery.noConflict(true);
        resolve();
      });
    } else {
      delivery_jQuery = jQuery;
      resolve();
    }
  });
}

function getScript({ source }) {
  return new Promise((resolve) => {
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = source;
    s.onload = s.onreadystatechange = function (_, isAbort) {
      if (isAbort || !s.readyState || /loaded|complete/.test(s.readyState)) {
        s.onload = s.onreadystatechange = null;
        s = undefined;

        if (!isAbort) {
          resolve();
        }
      }
    };
    var x = document.getElementsByTagName("script")[0];
    x.parentNode.insertBefore(s, x);
  });
}
function disableAddToCart() {
  const addToCartButton = "form[action^='/cart/add'] :submit[name='add']";
  setTimeout(() => {
    delivery_jQuery(addToCartButton).attr("disabled", "disabled");
  }, 1);
}

function disableCheckout() {
  const checkoutButton = ':submit[name="checkout"]:last';
  delivery_jQuery(checkoutButton).attr("disabled", "disabled");
}
